export default __webpack_public_path__ + "static/media/world.710f50ef.jpg";